function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledCarouselTitleComponent } from "./carousel-title-component.scss";
import Title from "segments/desktop/core-components/title/title";
import { TitlePrevCarouselArrow } from "./title-prev-carousel-arrow";
import { TitleNextCarouselArrow } from "./title-next-carousel-arrow";
const CarouselTitleComponent = ({ title, onPrevClick, onNextClick, visibleCards, setIsPaused })=>{
    const _ref = title || {}, { withArrows, marginBottom, arrowsAlignment, arrowColor } = _ref, titleConfig = _object_without_properties(_ref, [
        "withArrows",
        "marginBottom",
        "arrowsAlignment",
        "arrowColor"
    ]);
    return /*#__PURE__*/ _jsxs(StyledCarouselTitleComponent, {
        arrowsAlignment: arrowsAlignment,
        visibleCards: visibleCards,
        marginBottom: marginBottom,
        className: "carousel-title-component",
        children: [
            /*#__PURE__*/ _jsx(Title, _object_spread({}, titleConfig)),
            withArrows && /*#__PURE__*/ _jsxs("div", {
                className: "carousel-arrow-wrapper",
                onMouseEnter: ()=>setIsPaused(true),
                onMouseLeave: ()=>setIsPaused(false),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "carousel-arrow",
                        onClick: onPrevClick,
                        children: /*#__PURE__*/ _jsx(TitlePrevCarouselArrow, {
                            color: arrowColor
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "carousel-arrow",
                        onClick: onNextClick,
                        children: /*#__PURE__*/ _jsx(TitleNextCarouselArrow, {
                            color: arrowColor
                        })
                    })
                ]
            })
        ]
    });
};
export default CarouselTitleComponent;
